module.exports = __webpack_public_path__ + "static/images/logo_en_52a132db.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo_en.png
// module id = 235
// module chunks = 1